import React from 'react';
import styled from 'styled-components';

import { Text } from '../../components/common/atom/Text';
import { Flex } from '../../components/common/atom/Layout';

import { useCopy } from '../../Hooks/useCopy';
import ThemeStyle from '../../lib/style/ThemeStyle';

const FriendPaybackListItem = ({
  item = {
    createDateTime: '2022-06-20 13:50:50',
    voucherCode: 'ABCDEFG',
    delegationCount: 0,
    useCount: 0,
  },
}) => {
  const { onCopyToClipboard } = useCopy();

  return (
    <Flex
      column
      alignItems="stretch"
      width="100%"
      padding="1.25rem"
      style={{ borderBottom: `${ThemeStyle.color.pinkishGrey} 1px solid` }}
    >
      <Text size={14} weight="medium">
        {item.createDateTime}
      </Text>
      <Flex padding="1.25rem 0 0">
        <ItemText
          borderColor="orangePink"
          onClick={(e) =>
            onCopyToClipboard({
              text: item.voucherCode,
              message: LANG.alertCopyClipboard,
              error: LANG.alertCopyClipboardError,
            })
          }
          textAlign="center"
        >
          {LANG.titlePaybackCode}
          <Text color="orangePink">{` [${item.voucherCode}] `}</Text>
          {LANG.titleCopy}
        </ItemText>
      </Flex>
      <Flex padding="1.25rem 0 0">
        <ItemText borderColor="brownGrey">
          {LANG.titleRegisteredCount}
          <Text color="orangePink">{` ${item.delegationCount}`}</Text>
        </ItemText>
        <ItemText borderColor="brownGrey">
          {LANG.titleUsedCount}
          <Text color="orangePink">{` ${item.useCount}`}</Text>
        </ItemText>
      </Flex>
    </Flex>
  );
};

export default FriendPaybackListItem;

const LANG = {
  titleRegisteredCount: '등록 개수',
  titleUsedCount: '사용 개수',
  titlePaybackCode: '친구추천코드',
  titleCopy: '복사하기',
  alertCopyClipboard: '친구추천코드가 복사되었습니다.',
  alertCopyClipboardError:
    '친구추천코드 복사에 실패하였습니다.\n\n코드를 2초간 누른 후 "복사"버튼을 누르면 클립보드에 코드가 복사됩니다.',
};

const ItemText = styled(Text)`
  width: 100%;
  border: ${(props) => `1px solid ${props.theme.color[props.borderColor]}`};
  border-radius: 6px;
  padding: 0.625rem;

  &,
  span {
    text-align: center;
    font-weight: bold;
    font-size: 0.875rem;
  }

  & + & {
    margin-left: 1.125rem;
  }
`;
